import { useState, useCallback } from 'preact/hooks';
import { IcoChat } from '@components/icons';
import { useCurrentUser } from 'client/lib/auth';
import { hasLevel } from 'shared/auth';
import { useEsc } from 'client/utils/use-esc';
import { FeedbackForm } from './feedback-form';

export function FeedbackWidget() {
  const user = useCurrentUser();
  const [formOpen, setFormOpen] = useState(false);

  const close = useCallback(() => {
    setFormOpen(false);
  }, []);

  useEsc(close, { respectDefault: true, escapeOnly: true });

  if (!user || !hasLevel(user, 'guide')) {
    return undefined;
  }

  return (
    <>
      {!formOpen && (
        <button
          type="button"
          onClick={() => setFormOpen(true)}
          class="fixed bottom-6 left-6 z-[49] w-12 h-12 rounded-full shadow-lg flex items-center justify-center transition-colors bg-blue-600 hover:bg-blue-700 text-white"
          title="Send feedback"
        >
          <IcoChat class="w-5 h-5" />
        </button>
      )}

      {formOpen && (
        <FeedbackForm
          pagePath={window.location.pathname}
          reporterName={user.name || user.email}
          onClose={close}
        />
      )}
    </>
  );
}
